<template>
  <HScaffold :hideLeftBackBtn="hideLeftBackBtn" :hideNav="hideNav" title="充值">
    <div style="display:flex;flex-direction: row;align-items: center;margin:10px;justify-content: space-between;">
      <div :style="{
        background: HNewGameUIConfig.newGameUIType === 3?'linear-gradient(to right, black, transparent)':'',
        padding:HNewGameUIConfig.newGameUIType === 3?'5px 30px 5px 10px':'',
        borderTopLeftRadius:'20px',
        borderBottomLeftRadius: '20px',
        display: 'flex',
        flexDirection: 'row',
        alignItems:' center',
      }">
        <div :style="hcf.getTextStyle({
        color:HNewGameUIConfig.newGameUIType === 3? 'white':'#ff7d3f',marginRight:5,fontWeight:'bold',addSize:1
      })">
          我的余额:
        </div>
        <HShowRefreshBalance :moneySize="-3" :imgSize="20" :moneyColor="HNewGameUIConfig.newGameUIType === 3?'main':'#ff7d3f'"/>
      </div>
      <div @click="hr.go('account-detail', {'fromType': 1})" :style="hcf.getTextStyle({color:'main',addSize:-1})">充值历史</div>
    </div>
    <HPayWithdrawContainer title="支付方式">
      <div class="wrapContent">
        <div @click="choosePayType(item)" :style="{
          width:eachTileWidth+'px',
          marginLeft:index % 4 !==0 ? '8px':'0',
          marginTop:index>3?'10px':'0',
          backgroundColor:getEachContainerBgColor(selectPayTypeItem['Id'] === item['Id']),
          border:getEachContainerBorderColor(selectPayTypeItem['Id'] === item['Id']),
        }" class="eachWrapTile"
             v-for="(item,index) in allPayList" :key="item['Id']">
          <HCacheImage :src="item['Icon']" height="20px"/>
          <div :style="hcf.getTextStyle({
              marginTop:3,
              color:selectPayTypeItem['Id'] === item['Id']?(HNewGameUIConfig.newGameUIType === 3
                                          ? 'white'
                                          : 'black'):(HNewGameUIConfig.newGameUIType === 3
                                          ? '#aaa'
                                          : '#777'),
              fontWeight:selectPayTypeItem['Id'] === item['Id']?'bold':'normal'
          })">{{ item['Name'] }}
          </div>
          <img v-if="item['Commend']" :src="icon_flag_hot" style="position:absolute;top:0;left:0;height:26px;" alt="">
        </div>
      </div>
    </HPayWithdrawContainer>
    <HPayWithdrawContainer title="支付渠道" :desc="selectPayChannelItem['Desc']">
      <div ref="scrollContainerRef" class="scrollContentDiv">
        <div @click="chooseChannelType(item,index)"
             :style="{
                backgroundColor:getEachContainerBgColor(selectPayChannelItem['Id'] === item['Id']),
                border:getEachContainerBorderColor(selectPayChannelItem['Id'] === item['Id']),
             }"
             :class="['eachScrollDiv',selectPayChannelItem['Id'] === item['Id']?'eachScrollDivActive':'']"
             v-for="(item,index) in selectPayTypeItem['Channels']" :key="item['Id']">
          <HCacheImage :src="item['Icon']" height="30px"/>
          <div
              style="margin-left: 5px;display:flex;flex-direction: column;align-items: flex-start;justify-content: center;width: 100%;">
            <div :style="hcf.getTextStyle({
              addSize:0,color:selectPayChannelItem['Id'] === item['Id']?(HNewGameUIConfig.newGameUIType === 3
                                          ? 'white'
                                          : 'black'):(HNewGameUIConfig.newGameUIType === 3
                                          ? '#aaa'
                                          : '#777'),fontWeight:selectPayChannelItem['Id'] === item['Id']?'bold':'normal'
            })">{{ item['Name'] }}
            </div>
            <div :style="hcf.getTextStyle({
              addSize:-3,color:'#888'
            })">{{
                (item["MinMoney"] != 0 && item["MaxMoney"] != 0)
                    ? ('单笔' + processKLogic(hcf.getMoneyValue(item["MinMoney"], {saveCount: 0})) + '~' + processKLogic(hcf.getMoneyValue(item["MaxMoney"], {saveCount: 0})) + '元')
                    : "可选固定充值金额"
              }}
            </div>
          </div>
          <img v-if="item['Commend']" :src="icon_flag_hot" style="position:absolute;top:0;left:0;height:26px;" alt="">
          <div v-if="item['AwardDesc']!==''"
               style="background-color: #f33;padding:0 6px;border-radius: 20px;position:absolute;top:-10px;right:-18px;">
            <div :style="hcf.getTextStyle({
                color:'#fff',addSize:-3
            })">{{ item['AwardDesc'] }}
            </div>
          </div>
        </div>
      </div>
    </HPayWithdrawContainer>
    <HPayWithdrawContainer title="充值金额">
      <div :style="{
        display:'flex',
        flexDirection: 'column',
        marginTop: isCanShowInput?'10px':'0'
      }">
        <div v-if="selectPayChannelItem['MinMoney']!==0 && selectPayChannelItem['MaxMoney']!==0"
             style="border:#333 1px solid;border-radius:6px;padding:6px 10px;display:flex;flex-direction: row;align-items: center;">
          <div :style="hcf.getTextStyle({
              addSize:3,
          })">¥
          </div>
          <van-field
              :style="{
                margin:0,
                padding:'0 10px',
                fontSize:'14px',
                backgroundColor:'#0000',
              }"
              maxlength="10"
              type="number"
              v-model="payMoneyValue"
              :placeholder="isCanShowMoneyList?'请输入充值金额(或选择金额）':'请输入充值金额'"
              @input="onInput()"
              @blur="checkMaxMinValue"
              @change="checkMaxMinValue"
          />
        </div>
        <div
            class="moneyListDiv"
            :style="{marginTop:isCanShowInput?'20px':'10px'}"
            v-if="isCanShowMoneyList">

          <div v-for="(mValue,index) in selectPayChannelItem['MoneyList']" :key="mValue">
            <div @click="pressEachMoney(mValue)" :style="{
              width:eachTileWidth+'px',
              backgroundColor:getEachContainerBgColor(!isCanShowInput && payMoneyValue === hcf.getMoneyValue(mValue,{saveCount:0})),
              borderRadius:'6px',
              padding:'8px 0',
              marginLeft:index % 4 !==0 ? '8px':'0',
              marginTop:index>3?'10px':'0',
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'center',
              border:!isCanShowInput && payMoneyValue === hcf.getMoneyValue(mValue,{saveCount:0})?`${hcf.getMainColor()} 2px solid`:(HNewGameUIConfig.newGameUIType === 3?'#222 2px solid':'white 2px solid')
            }">
              <div :style="hcf.getTextStyle({
                textAlign:'center',fontWeight:'bold',marginRight:1
          })">
                ¥
              </div>
              <div :style="hcf.getTextStyle({
                textAlign:'center',fontWeight:'bold',addSize:1
          })">
                {{ hcf.getMoneyValue(mValue, {saveCount: 0}) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <HButton :callback="requestPay" :disabled="!isCanGo" title="充值"/>
      <div @click="()=>{
        useHComApi().openService();
      }" style="display: flex;flex-direction: row;align-items: center;justify-content: center;">
        <div :style="hcf.getTextStyle({
        color:'#aaa',marginRight:5,
      })">
          遇到充值问题，请联系
        </div>
        <div :style="hcf.getTextStyle({
        color:'main',marginRight:5
      })">
          在线客服
        </div>
      </div>
    </HPayWithdrawContainer>
    <div :style="hcf.getTextStyle({
        marginTop:10,color:'#aaa',marginLeft:10,marginRight:10,addSize:-2
      })">{{noticeStr}}</div>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import HShowRefreshBalance from "@/components/utils/HShowRefreshBalance.vue";
  import HPayWithdrawContainer from "@/components/utils/HPayWithdrawContainer.vue";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import icon_flag_hot from "@/assets/icons/common/flag_hot.png";
  import {ref} from "vue";
  import HButton from "@/components/utils/HButton.vue";
  import {showDialog, showToast} from "vant";
  import {useUserStore} from "@/stores/useUser.js";
  import {hr} from "@/components/utils/HRouter.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  let useUser = useUserStore();

  let useHttp = useHHttp();
  const allPayList = ref([]);
  const noticeStr = ref("");
  const eachTileWidth = ref(0);

  const selectPayTypeItem = ref({id: 0});
  const selectPayChannelItem = ref({id: 0});

  const scrollContainerRef = ref();

  const payMoneyValue = ref("");

  const isCanShowInput = ref(true);
  const isCanShowMoneyList = ref(true);

  const isCanGo = ref(false);

  defineProps(["hideLeftBackBtn", "hideNav"]);


  function getEachContainerBgColor(isSelect){
    if(HNewGameUIConfig.newGameUIType === 3){
      if(isSelect){
        return "#3F362E";
      }else{
        return "#191B15";
      }
    }else{
      return "#f7f7f7";
    }
  }
  function getEachContainerBorderColor(isSelect){
    if(isSelect){
      return "var(--ct-main-color) 2px solid";
    }else{
      if(HNewGameUIConfig.newGameUIType === 0){
        return "#f7f7f7 2px solid";
      }else if(HNewGameUIConfig.newGameUIType === 3){
        return "#333333 2px solid";
      }else{
        return "#fafafaaa 2px solid";
      }
    }
  }



  function requestPay(){

    if (payMoneyValue.value === "") {
      return showToast("请先输入或选择充值金额");
    }
    //需要实名
    let isNeedName = selectPayChannelItem.value["NeedName"] ?? false;
    if (isNeedName && useUser.realName === "") {
      showDialog({
        title: '充值提醒',
        message: "当前支付渠道需要先进行实名",
        cancelButtonText:"暂不",
        showCancelButton:true,
        confirmButtonText: "去实名",
        confirmButtonColor: hcf.getMainColor()
      }).then(()=>{
        hr.go("editor", {
          "hintText": "姓名必须与银行持卡人一致",
          "title": "设置真实姓名",
          "successCallBack": (value) => {
            useHttp.request("/app/profile/modify-base", () => {
              showToast("实名成功");
              useUser.realName = value;
              hr.goBack();
            }, {
              params: {
                "AppId": useUser.appId,
                "UserId": useUser.userId,
                "RealName": value,
              }
            });
          }
        });
      }).catch(()=>{});
    }else{

        useHttp.request("/qp/recharge/channel/prepare", (data)=>{

          showDialog({
            title: `确认支付${payMoneyValue.value}元？`,
            cancelButtonText:"取消",
            showCancelButton:true,
            confirmButtonText: "确认",
            confirmButtonColor: hcf.getMainColor()
          }).then(()=>{
            if(hdi.isRunDesktop && HNewGameUIConfig.newGameUIType === 3){
              window.parent?.postMessage(`${data["MidUrl"]}|mgpay`, "*"); // "*" 表示允许任意来源接收
            }else{
              hcf.launchUrl(data["MidUrl"]);
            }
            setTimeout(()=>{
              showDialog({
                title: "请确认支付结果",
                cancelButtonText:"暂未支付",
                showCancelButton:true,
                confirmButtonText: "我已支付",
                confirmButtonColor: hcf.getMainColor()
              }).then(()=>{
                const api = useHComApi();
                api.refreshUserBalance();
                api.fetchRedDot();
                showDialog({
                  title: "温馨提醒",
                  message:"请检查您的金额，如果10分钟之内未到账，请联系《人工客服》",
                  confirmButtonText: "知道了",
                  confirmButtonColor: hcf.getMainColor()
                }).then(()=>{
                  hr.go("account-detail", {"fromType": 1});
                }).catch(()=>{
                });
              }).catch(()=>{
                useHComApi().refreshUserBalance();
              });
            },1000);
          }).catch(()=>{});
        }, {
          params: {
            "PayChannelId": selectPayChannelItem.value["Id"],
            "PayAmount": Math.floor(payMoneyValue.value) * 100,
            "ClientPlat": 3
          }
        });

    }
  }


  function checkIsCanGoPay() {
    isCanGo.value = selectPayChannelItem.value != null && selectPayTypeItem.value != null && payMoneyValue.value !== "";
  }

  function onInput() {
    checkIsCanGoPay();
  }

  function checkMaxMinValue(){
    let intMoneyValue = parseInt(payMoneyValue.value);
    let minMoney = Math.floor(selectPayChannelItem.value["MinMoney"]/100);
    let maxMoney = Math.floor(selectPayChannelItem.value["MaxMoney"]/100);
    if(intMoneyValue<minMoney){
      payMoneyValue.value =  minMoney+"";
      showToast("充值金额不可小于 "+minMoney);
    }
    if(intMoneyValue>maxMoney){
      payMoneyValue.value =  maxMoney+"";
      showToast("充值金额不可大于 "+maxMoney);
    }
  }

  function pressEachMoney(value) {
    payMoneyValue.value = hcf.getMoneyValue(value, {saveCount: 0});
    checkIsCanGoPay();
  }

  function scrollToCenter(index, isAnimate = true) {
    let targetYValue = 155 * (index - 1) + 50;
    if (isAnimate) {
      scrollContainerRef.value.scrollTo({
        left: targetYValue,
        behavior: 'smooth'
      });
    } else {
      scrollContainerRef.value.scrollLeft = targetYValue;
    }
  }

  function choosePayType(item) {
    selectPayTypeItem.value = item;
    selectPayChannelItem.value = selectPayTypeItem.value["Channels"][0];
    scrollContainerRef.value.scrollLeft = 0;
    payMoneyValue.value = "";
    updateCheck();
    checkIsCanGoPay();
  }

  function updateCheck() {
    isCanShowMoneyList.value = (selectPayChannelItem.value['MoneyList'] != null && selectPayChannelItem.value['MoneyList'].length > 0);
    isCanShowInput.value = selectPayChannelItem.value["MinMoney"] !== 0 && selectPayChannelItem.value["MaxMoney"] !== 0;
  }

  function chooseChannelType(item, index) {
    selectPayChannelItem.value = item;
    payMoneyValue.value = "";
    updateCheck();
    scrollToCenter(index);
    checkIsCanGoPay();
  }

  function processKLogic(numberStr) {
    const number = parseInt(numberStr) || 0;

    if (number < 1000) {
      return numberStr;
    } else if (number >= 10000) {
      const result = number / 10000;
      return Number.isInteger(result)
          ? `${parseInt(result + '')}万`
          : `${result.toFixed(1)}万`;
    } else {
      const result = number / 1000;
      return Number.isInteger(result)
          ? `${parseInt(result + '')}千`
          : `${result.toFixed(1)}千`;
    }
  }

  onMounted(() => {
    eachTileWidth.value = (window.innerWidth - 40 - 30) / 4;
    useHttp.request("/qp/recharge/channel/list", (data) => {
      noticeStr.value = data["Notice"].replaceAll("/n", '\n');
      allPayList.value = data["PayTypes"];

      selectPayTypeItem.value = allPayList.value[0];
      selectPayChannelItem.value = selectPayTypeItem.value["Channels"][0];
      updateCheck();
    });
  });
</script>


<style scoped>
  .moneyListDiv {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }

  .eachScrollDiv {
    display: flex;
    flex-shrink: 0;
    margin-right: 20px;
    border-radius: 8px;
    padding: 2px 8px;
    height: 45px;
    flex-direction: row;
    align-items: center;
    background-color: #f7f7f7;
    border: #f3f3f3 2px solid;
    position: relative;
  }

  .eachScrollDivActive {
    border: var(--ct-main-color) 2px solid;
  }

  .scrollContentDiv {
    padding-top: 10px;
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* iOS 流畅滚动 */
    scrollbar-width: none; /* Firefox */
  }

  .eachWrapTile {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5px 0;
    border-radius: 8px;
    position: relative;
  }

  .wrapContent {
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
  }

  .scrollContentDiv::-webkit-scrollbar {
    display: none; /* Chrome */
  }

</style>
